<template>
  <div class="d-ib">
    <div class="rel d-ib" @mouseover="mask = true" @mouseleave="mask = false">
      <img :src="url" :height="height" alt="">
      <div @click="show = true" v-show="mask" class="abs c-pointer ta-c c-f abs-full" :style="`background:rgba(0,0,0,.4);line-height:${height}px`">
        查看大图
      </div>
    </div>
    <el-dialog append-to-body width="640px" :visible.sync="show">
      <img :src="url" width="600" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String
    },
    height: {
      type: String
    },

  },
  data() {
    return {
      mask: false,
      show: false
    }
  },
  methods: {
    hover() {
      mask: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Util/ImgUtil.vue